import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BenefitPlan } from '@app/models/benefits/benefit-plan.model';
import { BenefitShowMenuService } from '@app/modules/benefits/services';
import { AuthService } from '@app/services';
import { ChangeRequestIndexTable } from '@benefits/services/tables/change-request-table/change-request-index.table';
import { IndexView } from '@common/views/index/index.view';

@Component({
    templateUrl: './change-request-index.template.html',
    styleUrls: ['./change-request-index.style.scss'],
})
export class ChangeRequestIndexView extends IndexView {
    isLoading = false;
    table: ChangeRequestIndexTable;
    benefitPlan: BenefitPlan;

    constructor(
        private route: ActivatedRoute,
        protected auth: AuthService,
        public benefitShowMenuService: BenefitShowMenuService
    ) {
        super();
        this.benefitPlan = this.route.snapshot.data.models.get('benefitPlan');

        this.table = new ChangeRequestIndexTable(this.auth, this.benefitPlan);
    }
}
